import axios from 'axios';

const abortControllers = new Map<string, AbortController>();

export function abortRequest (key: string): void {
	abortControllers.get(key)?.abort();
}

export async function abortableRequest<T> (
	key: string,
	request: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
	abortControllers.get(key)?.abort();
	const controller = new AbortController();
	abortControllers.set(key, controller);
	try {
		return await request(controller.signal);
	}
	finally {
		if (abortControllers.get(key) === controller) {
			abortControllers.delete(key);
		}
	}
}

export async function ignoringAbort (request: () => Promise<unknown>): Promise<void> {
	try {
		await request();
	}
	catch (err) {
		if (axios.isCancel(err)) { return; }
		throw err;
	}
}
